import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface JobApplication {
  jobId: number;
  fullName: string;
  email: string;
  phone: string;
  location: string;
  portfolio?: string;
  experience: string;
  resume: File | null;
}
export interface JobDetail {
  id: number;
  uid: string;
  position_category: string;
  title: string;
  min_experience: number;
  max_experience: number;
  min_ctc: number;
  max_ctc: number;
  location: string;
  description: string;
  status: string;
  is_locked: boolean;
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
}

@Injectable({
  providedIn: 'root'
})
export class JobViewService {
  private getJobDetailApiUrl = environment.baseUrl + environment.getJobDetailApiUrl;
 private applyJobApiUrl = environment.baseUrl + environment.applyJobApi;
  constructor(private http: HttpClient) {}

 applyJob(data: JobApplication): Observable<any> {
    const formData = new FormData();
    formData.append('jobId', data.jobId.toString());
    formData.append('fullName', data.fullName);
    formData.append('email', data.email);
    formData.append('phone', data.phone);
    formData.append('location', data.location);
    formData.append('portfolio', data.portfolio || '');
    formData.append('experience', data.experience);
    if (data.resume) formData.append('resume', data.resume);

    return this.http.post(this.applyJobApiUrl, formData).pipe(
      catchError(err => {
        console.error('Error submitting job application', err);
        return of({ success: false, message: 'Server error' });
      })
    );
  }

getJobDetail(positionId: number): Observable<JobDetail | null> {
  return this.http.get<JobDetail>(`${this.getJobDetailApiUrl}${positionId}`).pipe(
    catchError((err) => {
      console.error('Error fetching job detail', err);
      return of(null);
    })
  );
}
}
